<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    // 判断移动端还是pc端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  mounted: function() {
    let path = this.$route.path;

    console.log("当前路由", this.$route.path, this._isMobile());

   // path = "/";
   // this.$router.replace(path).catch(data => {});
   // return

    if (this._isMobile()) {
      path = "/move";
      // return
      // if (path == "/moIndex"||path.indexOf('/web')!=-1||path == '/') {
        
      // }
    } else {
      if (path == "/"||path.indexOf('/mo')!=-1) {
        path = "/home";
      }
    }
    this.$router.replace(path).catch(data => {});
  }

};
</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }
  body {
    background: #fcfcfc;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue